var map = {
	"./AC.svg": 16484,
	"./AD.svg": 84075,
	"./AE.svg": 90202,
	"./AF.svg": 51369,
	"./AG.svg": 26008,
	"./AI.svg": 21582,
	"./AL.svg": 79763,
	"./AM.svg": 76034,
	"./AO.svg": 18752,
	"./AQ.svg": 76214,
	"./AR.svg": 96501,
	"./AS.svg": 74868,
	"./AT.svg": 36219,
	"./AU.svg": 67402,
	"./AW.svg": 20680,
	"./AX.svg": 36303,
	"./AZ.svg": 62525,
	"./BA.svg": 12915,
	"./BB.svg": 42016,
	"./BD.svg": 79470,
	"./BF.svg": 28876,
	"./BG.svg": 8589,
	"./BH.svg": 17466,
	"./BI.svg": 36523,
	"./BJ.svg": 97688,
	"./BL.svg": 29958,
	"./BM.svg": 17495,
	"./BN.svg": 74372,
	"./BO.svg": 29093,
	"./BQ.svg": 38211,
	"./BR.svg": 76720,
	"./BS.svg": 5313,
	"./BT.svg": 80030,
	"./BV.svg": 63580,
	"./BW.svg": 34205,
	"./BY.svg": 31195,
	"./BZ.svg": 49832,
	"./CA.svg": 11164,
	"./CC.svg": 27614,
	"./CD.svg": 36545,
	"./CF.svg": 85795,
	"./CG.svg": 47858,
	"./CH.svg": 71349,
	"./CI.svg": 29364,
	"./CK.svg": 30102,
	"./CL.svg": 5337,
	"./CM.svg": 97416,
	"./CN.svg": 78779,
	"./CO.svg": 44586,
	"./CR.svg": 31807,
	"./CU.svg": 89600,
	"./CV.svg": 60499,
	"./CW.svg": 81506,
	"./CX.svg": 76677,
	"./CY.svg": 21956,
	"./CZ.svg": 48727,
	"./DE.svg": 91453,
	"./DJ.svg": 54250,
	"./DK.svg": 88443,
	"./DM.svg": 81013,
	"./DO.svg": 26887,
	"./DZ.svg": 74714,
	"./EC.svg": 29088,
	"./EE.svg": 4174,
	"./EG.svg": 63084,
	"./EH.svg": 78059,
	"./ER.svg": 46849,
	"./ES.svg": 48400,
	"./ET.svg": 65871,
	"./EU.svg": 86942,
	"./FI.svg": 76551,
	"./FJ.svg": 5044,
	"./FK.svg": 49973,
	"./FM.svg": 20315,
	"./FO.svg": 20697,
	"./FR.svg": 10668,
	"./GA.svg": 85112,
	"./GB.svg": 35851,
	"./GD.svg": 98693,
	"./GE-AB.svg": 5140,
	"./GE-OS.svg": 4743,
	"./GE.svg": 31172,
	"./GF.svg": 74295,
	"./GG.svg": 59910,
	"./GH.svg": 58065,
	"./GI.svg": 22112,
	"./GL.svg": 7917,
	"./GM.svg": 8972,
	"./GN.svg": 87999,
	"./GP.svg": 61529,
	"./GQ.svg": 79784,
	"./GR.svg": 30523,
	"./GS.svg": 70154,
	"./GT.svg": 77013,
	"./GU.svg": 20756,
	"./GW.svg": 5142,
	"./GY.svg": 80496,
	"./HK.svg": 13415,
	"./HM.svg": 7033,
	"./HN.svg": 57738,
	"./HR.svg": 11918,
	"./HT.svg": 9088,
	"./HU.svg": 23473,
	"./ID.svg": 3251,
	"./IE.svg": 24258,
	"./IL.svg": 26859,
	"./IM.svg": 7802,
	"./IN.svg": 22889,
	"./IO.svg": 88024,
	"./IQ.svg": 70366,
	"./IR.svg": 24541,
	"./IS.svg": 53916,
	"./IT.svg": 28547,
	"./JE.svg": 7559,
	"./JM.svg": 80527,
	"./JO.svg": 72125,
	"./JP.svg": 55386,
	"./KE.svg": 19896,
	"./KG.svg": 53466,
	"./KH.svg": 95565,
	"./KI.svg": 43756,
	"./KM.svg": 9760,
	"./KN.svg": 499,
	"./KP.svg": 83061,
	"./KR.svg": 9639,
	"./KW.svg": 27786,
	"./KY.svg": 67516,
	"./KZ.svg": 46543,
	"./LA.svg": 5065,
	"./LB.svg": 63130,
	"./LC.svg": 84747,
	"./LI.svg": 59985,
	"./LK.svg": 10163,
	"./LR.svg": 37450,
	"./LS.svg": 63067,
	"./LT.svg": 47796,
	"./LU.svg": 92725,
	"./LV.svg": 79766,
	"./LY.svg": 37185,
	"./MA.svg": 85034,
	"./MC.svg": 29288,
	"./MD.svg": 66887,
	"./ME.svg": 27350,
	"./MF.svg": 40309,
	"./MG.svg": 95380,
	"./MH.svg": 52419,
	"./MK.svg": 86320,
	"./ML.svg": 3791,
	"./MM.svg": 24862,
	"./MN.svg": 36957,
	"./MO.svg": 24764,
	"./MP.svg": 15979,
	"./MQ.svg": 10714,
	"./MR.svg": 52649,
	"./MS.svg": 77144,
	"./MT.svg": 72215,
	"./MU.svg": 9414,
	"./MV.svg": 45637,
	"./MW.svg": 67620,
	"./MX.svg": 57747,
	"./MY.svg": 43522,
	"./MZ.svg": 7569,
	"./NA.svg": 64631,
	"./NC.svg": 89029,
	"./NE.svg": 26187,
	"./NF.svg": 75448,
	"./NG.svg": 79689,
	"./NI.svg": 78335,
	"./NL.svg": 28034,
	"./NO.svg": 48401,
	"./NP.svg": 95478,
	"./NR.svg": 11092,
	"./NU.svg": 20859,
	"./NZ.svg": 57692,
	"./OM.svg": 59236,
	"./PA.svg": 74629,
	"./PE.svg": 81641,
	"./PF.svg": 39706,
	"./PG.svg": 44971,
	"./PH.svg": 29996,
	"./PK.svg": 9023,
	"./PL.svg": 96000,
	"./PM.svg": 36561,
	"./PN.svg": 72514,
	"./PR.svg": 56342,
	"./PS.svg": 95879,
	"./PT.svg": 58280,
	"./PW.svg": 39643,
	"./PY.svg": 65949,
	"./QA.svg": 3926,
	"./RE.svg": 13295,
	"./RO.svg": 43925,
	"./RS.svg": 24977,
	"./RU.svg": 54911,
	"./RW.svg": 74829,
	"./SA.svg": 76524,
	"./SB.svg": 55551,
	"./SC.svg": 40910,
	"./SD.svg": 52465,
	"./SE.svg": 38080,
	"./SG.svg": 95362,
	"./SH.svg": 33061,
	"./SI.svg": 35812,
	"./SJ.svg": 90263,
	"./SK.svg": 84934,
	"./SL.svg": 70697,
	"./SM.svg": 45336,
	"./SN.svg": 3403,
	"./SO.svg": 9530,
	"./SR.svg": 55631,
	"./SS.svg": 35582,
	"./ST.svg": 52961,
	"./SV.svg": 51235,
	"./SX.svg": 15829,
	"./SY.svg": 94196,
	"./SZ.svg": 42407,
	"./TA.svg": 62129,
	"./TC.svg": 8755,
	"./TD.svg": 86188,
	"./TF.svg": 50574,
	"./TG.svg": 65215,
	"./TH.svg": 55000,
	"./TJ.svg": 19194,
	"./TK.svg": 13067,
	"./TL.svg": 45476,
	"./TM.svg": 42725,
	"./TN.svg": 94598,
	"./TO.svg": 99927,
	"./TR.svg": 2348,
	"./TT.svg": 62972,
	"./TV.svg": 45246,
	"./TW.svg": 65295,
	"./TZ.svg": 96394,
	"./UA.svg": 5170,
	"./UG.svg": 10556,
	"./UK.svg": 97256,
	"./UM.svg": 36438,
	"./US.svg": 95328,
	"./UY.svg": 66778,
	"./UZ.svg": 27945,
	"./VA.svg": 60799,
	"./VC.svg": 85165,
	"./VE.svg": 89491,
	"./VG.svg": 81393,
	"./VI.svg": 77719,
	"./VN.svg": 57912,
	"./VU.svg": 14787,
	"./WF.svg": 93799,
	"./WS.svg": 41626,
	"./XK.svg": 83959,
	"./YE.svg": 80146,
	"./YT.svg": 115,
	"./ZA.svg": 93739,
	"./ZM.svg": 45887,
	"./ZW.svg": 6165
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 38882;